import { render, staticRenderFns } from "./SliceEmbed.vue?vue&type=template&id=17d72391&scoped=true"
import script from "./SliceEmbed.vue?vue&type=script&lang=js"
export * from "./SliceEmbed.vue?vue&type=script&lang=js"
import style0 from "./SliceEmbed.vue?vue&type=style&index=0&id=17d72391&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d72391",
  null
  
)

export default component.exports